<template>
  <div>
    <el-dialog v-dialogDrag :title="!!config.isReadOnly ? '查看检验结果' : '检测录入'" :visible.sync="visible" width="1400px"
      :close-on-click-modal="false" @close="onClose" @open="onOpen">
      <div id="dyBox" ref="dyBox" class="params_template">
        <div class="template_content">
          <Template1 v-if="index === '1'" ref="template1" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template2 v-if="index === '2'" ref="template2" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template3 v-if="index === '3'" ref="template3" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template4 v-if="index === '4'" ref="template4" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template5 v-if="index === '5'" ref="template5" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template6 v-if="index === '6'" ref="template6" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template7 v-if="index === '7'" ref="template7" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template8 v-if="index === '8'" ref="template8" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template9 v-if="index === '9'" ref="template9" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
          <Template10 v-if="index === '10'" ref="template10" :isViewResult="config.isReadOnly" :defaultData="defaultData"
            :saveData="saveData" :user="user" :buttonType="buttonType" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="onClose">{{ config.isReadOnly ? "关 闭" : "取 消" }}</el-button>
        <el-button v-if="!config.isReadOnly" class="bottom_all_two" @click="onSave()">保 存</el-button>
        <el-button v-if="config.isReadOnly" class="bottom_all_two" @click="print()">打 印</el-button>
        <el-button v-if="!config.isReadOnly" class="bottom_all" type="primary" @click="onSubmit">提交录入</el-button>
      </span>
    </el-dialog>
    <el-dialog title="结果判断" :visible.sync="visibleNg" width="500px" append-to-body @close="closeNg">
      <el-form ref="form" :model="form" label-width="140px" class="form">
        <el-form-item label="处理方式">
          <el-select v-model="form.handling" placeholder="请选择处理方式">
            <el-option label="复检" value="1"></el-option>
            <el-option label="异常处理" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="form.handling === '2'" label="异常现象">
          <el-input v-model="form.phenomena"></el-input>
        </el-form-item>
        <el-form-item v-show="form.handling === '2'" label="原因">
          <el-input v-model="form.cause"></el-input>
        </el-form-item>
        <el-form-item v-show="form.handling === '2'" label="拟处理方式">
          <el-radio-group v-model="form.type">
            <el-radio label="1">退货</el-radio>
            <el-radio label="2">条件接收</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeNg()">取 消</el-button>
        <el-button class="bottom_all" type="primary" @click="confirmNg()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Template1 from "./Tepmlate/Template1";
import Template2 from "./Tepmlate/Template2";
import Template3 from "./Tepmlate/Template3";
import Template4 from "./Tepmlate/Template4";
import Template5 from "./Tepmlate/Template5";
import Template6 from "./Tepmlate/Template6";
import Template7 from "./Tepmlate/Template7";
import Template8 from "./Tepmlate/Template8";
import Template9 from "./Tepmlate/Template9";
import Template10 from "./Tepmlate/Template10";
import { applyException } from "@/api/GHnumber/demand.js";
import { createOther } from '@/api/smart/checkout';
import { saveOrupdate, getDefaultData, getDetail, countResult, saveResul } from "@/api/index.js";
import { getQualityDetection1, getQualityDetection2 } from "@/api/qualityTemplate/index.js";
import { queryOne } from "@/api/cementMortar";
import { getUserInfo } from "@/utils/auth.js";
import html2canvas from "html2canvas";
import printJS from "print-js";
export default {
  components: {
    Template1,
    Template2,
    Template3,
    Template4,
    Template5,
    Template6,
    Template7,
    Template8,
    Template9,
    Template10,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => { },
    },
    checkOutData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      visibleNg: false,
      consignmentId: "",
      defaultData: {}, // 默认的基本数据
      saveData: {}, // 保存的数据
      buttonType: "", // 保存save 提交submit
      user: {
        inspector: null, // 试验人
        approver: null,
      },
      form: {
        handling: '2',
        type: '1',
        phenomena: '',
        cause: '',
      },
      index: "", // 模板索引,
      curUser: null,
      qualifiedStandard: null, // 质量标准
    };
  },
  mounted() {
    // 填充实验人
    this.curUser = getUserInfo();
  },
  methods: {
    print() {
      var element = document.getElementById("dyBox");
      var width = element.clientWidth;
      var height = element.clientHeight;
      html2canvas(document.getElementById("dyBox"), {
        width: width,
        height: height,
      }).then((canvas) => {
        var heatmapBase64 = canvas.toDataURL("image/png", 1);
        printJS({
          printable: heatmapBase64, //图片的数据
          type: "image",
          style:
            '@media print{ @page { size: auto; margin: 0; mso-header: none; mso-footer: none; } body{margin:0px  } img {display: block; margin: 0px;}}',
          base64: true,
          // imageStyle: 'width: 100%; height: 100vh; margin:0; padding: 0;',

        });
      });
    },
    getQualifiedStandard() {
      this.qualifiedStandard = "";
      // console.log('获取参数标准')
      getQualityDetection2({
        stationId: this.config.stationId,
        nameId: this.config.rawNameId,
        specificationId: this.config.specificationId,
        type: 1,
      }).then(res => {
        if (res && res.code === 1001) {
          if (res.data && res.data.tableSetting) {
            this.qualifiedStandard = JSON.parse(res.data.tableSetting);
          } else {
            getQualityDetection1({
              companyId: this.config.companyId,
              nameId: this.config.rawNameId,
              specificationId: this.config.specificationId,
              type: 1,
            }).then(res => {
              // console.log(res,"请求工厂标准");
              if (res && res.code === 1001) {
                if (res.data && res.data.tableSetting) {
                  this.qualifiedStandard = JSON.parse(res.data.tableSetting);
                }
              }
            });
          }
        }
      });
    },
    onOpen() {
      function fixJsonString(str) {
        return str
          .replace(/\\/g, '')    // 移除所有反斜杠 \
          .replace(/"\[/g, '[')  // 替换 "[ 为 [
          .replace(/\]"/g, ']')  // 替换 ]" 为 ]
          .replace(/"\{/g, '{')  // 替换 "{ 为 {
          .replace(/\}"/g, '}'); // 替换 }" 为 }
      }
      let cnt = 0;
      // 获取默认数据
      getDefaultData({ id: this.config.id }).then(async res => {
        cnt++;
        if (res && res.code === 1001)
          if (res.data) {
            this.defaultData = { ...res.data };
            this.defaultData.code = this.config.code;
            this.defaultData.stationId = this.config.stationId;
            if (res.data.content) {
              let dataObj = ""
              try {
                dataObj = JSON.parse(res.data.content);
              } catch (error) {
                console.error('JSON 解析失败:', error);
                let str1 = fixJsonString(res.data.content)
                dataObj = JSON.parse(str1)
              }
              
              this.defaultData.content = dataObj
            }
            this.user.approver = {
              label: res.data.reviewer,
              reviewerId: res.data.reviewerId,
            };
            // 获取水泥胶砂的基本数据
            const response = await queryOne({ stationId: this.defaultData.stationId });
            if (response && response.code === 1001 && res.data) {
              const data = response.data;
              if (data) {
                this.$set(this.defaultData, "sevenDayAvg", data.sevenDayAvg); // 7天水泥基准强度
                this.$set(this.defaultData, "twentyEightDayAvg", data.twentyEightDayAvg); // 28天水泥基准强度
                this.$set(this.defaultData, "referenceMobility", data.referenceMobility); // 基准流动度
              }
            }
          }

        if (cnt === 2) {
          this.initTpl();
        }
      });
      console.log("config: ", this.config);
      // 获取保存过的数据
      getDetail({ pid: this.config.id }).then(res => {
        cnt++;
        if (res && res.code === 1001) {
          if (res.data) {
              let dataObj2 = ""
              try {
                dataObj2 = JSON.parse(res.data.content);
              } catch (error) {
                console.error('JSON 解析失败:', error);
                let str1 = fixJsonString(res.data.content)
                dataObj2 = JSON.parse(str1)
              }
            this.saveData = dataObj2;
            // console.log(this.saveData, res.data.content)
            // 这里myData是前端自定义的数据，方便回显
            this.user.inspector = { value: res.data.inspectorId, label: res.data.inspector };
          }

          if (cnt === 2) {
            this.initTpl();
          }
        }
      });
      if (!this.config.isReadOnly) {
        this.getQualifiedStandard();
      }
    },
    initTpl() {
      // 根据原物料名称获取模板索引
      // const obj = {
      //   1: ["水泥", "高抗硫酸盐硅酸盐水泥"],
      //   2: "粉煤灰",
      //   3: "矿粉",
      //   4: "复合掺合料",
      //   5: ["机制砂", "天然砂", "机制砂（砂浆专用）","砂浆砂"],
      //   6: "碎石",
      //   7: "泵送剂",
      //   8: ["膨胀剂", "膨胀剂Ⅰ型","膨胀剂II型"],
      //   9: "硅灰",
      //   10: "聚丙烯纤维",
      // };
      console.log(this.user);

      if (!this.user.inspector || !this.user.inspector.value) {
        this.user.inspector = {
          value: this.curUser.userId,
          label: this.curUser.userRealName,
        };
      }
      // for (const key in obj) {
      //   if (typeof obj[key] === "string" && obj[key] === this.config.rawName) {
      //     this.index = key;
      //     break;
      //   }
      //   if (typeof obj[key] === "object") {
      //     for (let i = 0; i < obj[key].length; i++) {
      //       if (obj[key][i] === this.config.rawName) {
      //         this.index = key;
      //         break;
      //       }
      //     }
      //   }
      // }
      this.index = this.config.templeId
      console.log("引用模板：", this.index);
      console.log(this.defaultData)
      console.log(this.saveData)
      if (!this.index) {
        this.$message.warning('当前原物料未配置模板')
      }
    },

    onClose() {
      this.saveData = {};
      this.index = undefined;
      this.$emit("update:visible", false);
    },
    onSave(isSubmit) {
      console.log(isSubmit)
      this.buttonType = "save";
      this.$nextTick(() => {
        const formData = this.$refs["template" + this.index].getData();
        if (isSubmit) {
          // 检验数据
          for (let key in formData) {
            // console.log(key)
            if ([1, 3].indexOf(formData[key].category) >= 0 && (formData[key].resultValue === undefined || formData[key].resultValue.length === 0)) {
              this.$message.warning("请填写" + formData[key].title);
              return;
            }
          }
        }
        const params = {
          approver: this.defaultData.reviewer,
          approverId: this.defaultData.reviewerId,
          inspector: this.user.inspector.label,
          inspectorId: this.user.inspector.value,
          pid: this.config.id,
          consignmentId: this.config.consignmentId,
          content: JSON.stringify(formData),
        };
        if (isSubmit) {
          this.submitAction(formData);
        } else {
          saveOrupdate(params).then(res => {
            if (res && res.code === 1001) {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    onSubmit() {
      this.onSave(true);
    },
    closeNg() {
      this.visibleNg = false
      this.form = {
        handling: '2',
        type: '1',
        phenomena: '',
        cause: '',
      }
    },
    confirmNg() {

      if (this.form.handling === '1') { // 复检
        var params1 = {
          id: this.form.id,
          dataTypeId: '3',
          dataType: '复检',
          dataTypeStatus: 1,
        }
        createOther(params1).then(res => {
          if (res && res.code === 1001) {
            this.$message.success("保存成功");
            this.visibleNg = false
            this.$emit("update:visible", false);
          }
        });
      } else { // 异常处理
        this.form.type === '1' ? '退货' : '条件接收'
        var params2 = {
          consignmentId: this.form.consignmentId,
          type: 1,
          processMode: this.form.type === '1' ? '退货' : '条件接收',
          acceptableConditings: this.form.acceptableConditings,
          phenomena: this.form.phenomena,
          cause: this.form.cause,
        }
        applyException(params2).then(res => {
          if (res && res.code === 1001) {
            this.$message.success("保存成功");
            this.visibleNg = false
            this.$emit("update:visible", false);
          }
        });
      }

    },
    submitAction(formData) {
      this.buttonType = "submit";
      this.$nextTick(() => {
        // 填充判断标准
        for (let key in this.qualifiedStandard) {
          // if (/^cell/.test(key) && this.qualifiedStandard[key].category != 7) {
          if (/^cell/.test(key)) {
            // console.log(key)
            // console.log(key, this.qualifiedStandard[key].condition);
            if (formData[key] && (!formData[key].condition || formData[key].condition === undefined)) {
              formData[key].condition = this.qualifiedStandard[key].condition;
            }
          }
        }
        for (const key in formData) {
          // if (formData[key].type == 2) {
          //     if(formData[key].condition) {
          //         formData[key].condition = JSON.parse(formData[key].condition)
          //     }else {
          //         formData[key].condition = undefined
          //     }
          // }
          if (typeof formData[key].resultValue === "object") {
            formData[key].resultValue = JSON.stringify(formData[key].resultValue);
          }
        }
        const params = {
          pid: this.config.id,
          content: JSON.stringify(formData),
        };
        countResult(params).then(res => {
          if (res.code === 1001) {
            if (res.data.resultStatus === 4) {
              return this.$message.warning("数据异常:" + res.data.excetionProject);
            }
            const resultText = res.data.notQualified ? "NG" : "OK";
            const h = this.$createElement;
            this.$msgbox({
              title: "结果判断",
              message: h("div", null, [
                h("p", null, [h("span", null, "系统检测结果："), h("span", { style: `color: ${resultText === "OK" ? "green" : "#cc3300"}` }, resultText)]),
                h("p", { style: `display: ${res.data.resultStatus & (1 === 1) ? "block" : "none"}` }, "本次检验数据满足异常标准"),
              ]),
              showCancelButton: true,
              confirmButtonText: (res.data.resultStatus & 1) === 1 ? "提 交" : "保 存",
              cancelButtonText: "取消",
            }).then(action => {
              if (action === "confirm") {
                const params = {
                  pid: this.config.id,
                  handling: "",
                  imgs: "",
                  outcome: resultText,
                  qualified: res.data.notQualified, // 存入不合格数据
                  adjacent: res.data.adjacent,
                  // remark: tableData.bz,
                  detectionValue: {
                    approver: this.defaultData.approver,
                    approverId: this.defaultData.approverId,
                    inspector: this.user.inspector.label,
                    inspectorId: this.user.inspector.value,
                    pid: this.config.id,
                    consignmentId: this.config.consignmentId,
                    content: res.data.content, // 保存计算过的数据，包含结算结果
                  },
                };
                console.log(res.data.resultStatus & 1, res.data.resultStatus);
                if ((res.data.resultStatus & 1) === 0) {
                  // 保存
                  saveResul(params).then(res => {
                    if (res && res.code === 1001) {
                      this.$message.success("检验数据保存成功");
                      this.$emit("update:visible", false);
                    }
                  });
                } else {
                  saveResul(params).then(res => {
                    if (res && res.code === 1001) {
                      // this.$message.success("检验数据保存成功");
                      // this.$emit("update:visible", false);
                    }
                  });
                  // 审核
                  this.visibleNg = true
                  this.form.consignmentId = params.detectionValue.consignmentId
                  this.form.id = this.checkOutData.id
                  // const query = {
                  //   ...params,
                  //   detectionValue: JSON.stringify(params.detectionValue),
                  //   ...this.checkOutData,
                  //   outcome: resultText,
                  //   tableDataSource: JSON.stringify(res.data.anomalyCriteriaJson),
                  // };
                  // this.$emit("check", query);
                  // this.$emit("update:visible", false);
                }
              } else {
                console.log("cancel");
              }
            });
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
$td_width: 100px;
$td_height: 36px;

.params_template {
  .template_content {
    display: flex;
    justify-content: center;
  }

  .template_table_parent {
    margin: 0 30px 20px 20px;

    table {
      border-collapse: collapse;
      border: 0 !important;
    }

    td {
      position: relative;
    }

    table,
    th,
    td {
      border: 1px solid black;
    }

    .el-date-table {

      table,
      th,
      td {
        border: 0;
      }
    }

    .bg1 {
      // 必检
      background: #ffff00;
      cursor: pointer;
      color: #000;
    }

    .bg2 {
      // 选检
      background: #ffffcd;
      cursor: pointer;
      color: #000;
    }

    .bg3 {
      // 必填
      background: #00b14b;
      cursor: pointer;
      color: #000;
    }

    .bg4 {
      // 默认
      background: #8062a4;
      cursor: pointer;
      color: #000;
    }

    .bg5 {
      // 系统带入
      background: #fdd5b2;
      cursor: pointer;
      color: #000;
    }

    .bg6 {
      // 选填
      background: #90d246;
      cursor: pointer;
      color: #000;
    }

    .red {
      // 配置项颜色
      color: red;
      cursor: pointer;
    }

    .red-bg {
      background: red;
      color: #000;
    }

    .yellow-bg {
      background: #ffffcd;
      color: #000;
      cursor: pointer;
    }

    .el-icon-s-flag {
      float: right;
      color: #f56c6c;
      display: inline-block;
    }

    .template_table {
      .el-select {
        width: 100%;
      }

      .el-select__caret {
        // 下拉框的下拉箭头
        display: none;
      }

      .el-textarea__inner {
        // 文本域设置
        width: 100%;
        height: 100%;
        line-height: 36px;
        border: 0;
        outline: none;
        resize: none;
      }

      .el-input {
        width: 100%;
        text-align: center;
        cursor: pointer;
      }

      .el-input__inner {
        width: 100%;
        border: 0;
        border-radius: 0;
        background: transparent;
        color: #000;
        text-align: center;
        cursor: pointer;
      }

      .el-input__suffix {
        color: #000;
      }

      input::-webkit-input-placeholder {
        color: #000;
      }

      .select_date {
        .el-input__inner {
          width: 100%;
          border: 0;
          border-radius: 0;
          background: transparent;
          color: #000;
          padding: 0 10px;
          text-align: center;
          cursor: pointer;
        }

        .el-input__prefix {
          display: none;
        }
      }

      tr:first-child,
      tr:last-child {
        td {
          border: 0;
        }
      }

      td {
        width: $td_width;
        height: $td_height;
        text-align: center;
      }
    }
  }
}
</style>
